/* eslint-disable */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/training.scss';
import Paging from '../../component/Inc/Paging';
import Tab from '../../component/Inc/Tab';

const LearnerTraining = () => {
  const [tabIdx, setTabIdx] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const tab = [
    {title: '전체', value: 0},
    {title: '평가 대상자', value: 1},
    {title: '재 평가대상자', value: 2},
    {title: '승인', value: 3}
  ];
  return (
    <main className="com_container com_training p_learner_training">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu6_4">화상 평가</h2>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              <div className="com_board_list__top">
                <section className="com_board_search">
                  <div className="com_btn_wrap">
                    <button className="com_btn line gray s active">오늘</button>
                    <button className="com_btn line gray s">주간</button>
                    <button className="com_btn line gray s">월간</button>
                  </div>
                  <div className="date_wrap">
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    <span className="divider"> ~ </span>
                    <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    <button className="com_btn gray s">조회</button>
                  </div>
                </section>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                  <input type="radio" name="rdo" id="rdo08" className="com_chk circle" />
                  <label htmlFor="rdo08">논술</label>
                </div>
              </div>
            </div>

            <table className="com_board_list">
              <colgroup>
                <col width="50" />
                <col width="100" />
                <col width="60" />
                <col width="60" />
                <col width="60" />
                <col width="70" />
                <col width="auto" />
                <col width="60" />
                <col width="60" />
                <col width="60" />
                <col width="80" />
                <col width="100" />
                <col width="100" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>
                    입사일 &nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>지점</th>
                  <th>과목</th>
                  <th>이름</th>
                  <th>나이/성별</th>
                  <th>학력</th>
                  <th>면접</th>
                  <th>시강</th>
                  <th>등급</th>
                  <th>평가자</th>
                  <th>이전 평가</th>
                  <th>최근 평가</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>1</td>
                  <td className="td_date">2022,08,25</td>
                  <td>본사</td>
                  <td>수학</td>
                  <td>홍면접</td>
                  <td>29/남</td>
                  <td>울산과학기술원 에너</td>
                  <td>35</td>
                  <td>37</td>
                  <td>C-</td>
                  <td>
                    <Link to="/Training/VideoEvaluation/Register" className="btn_link blue">
                      평가등록
                    </Link>
                  </td>
                  <td>
                    <span className="com_red_txt">56</span>
                    <br />
                    2023, 05,12
                  </td>
                  <td>
                    <span className="com_blue_txt">56</span> <br />
                    2023, 05,12
                  </td>
                </tr>
                {[...Array(8)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td className="td_date">2022,08,25</td>
                    <td>본사</td>
                    <td>수학</td>
                    <td>홍면접</td>
                    <td>29/남</td>
                    <td>울산과학기술원 에너</td>
                    <td>35</td>
                    <td>37</td>
                    <td>C-</td>
                    <td>
                      <span className="btn_link">김평가103</span>
                    </td>
                    <td>
                      <span className="com_red_txt">56</span>
                      <br />
                      2023, 05,12
                    </td>
                    <td>
                      <span className="com_blue_txt">56</span> <br />
                      2023, 05,12
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_btn_wrap center">
              <div className="paging_wrap">
                <Paging />
              </div>
            </div>
          </section>
          <section className="box">
            <div className="detail_tit dot">교육 대상자 상세</div>
            <div className="com_info">
              <p className="name">홍길동103</p>
              <p className="date dot">2025, 05, 20 11 : 30</p>
              <div className="count">
                <button className="btn_edit"></button>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">지점/과목</span>
                  <span className="cont">본사 / 영어</span>
                </div>
                <div className="info">
                  <span className="tit">이름</span>
                  <span className="cont bold">김교사</span>
                </div>
                <div className="info">
                  <span className="tit">나이/성별</span>
                  <span className="cont">1979,12 / 여</span>
                </div>
                <div className="info">
                  <span className="tit">거주지</span>
                  <span className="cont com_blue_txt">서울 / 송파구</span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <span className="cont com_blue_txt">010-1234-4567</span>
                </div>
                <div className="info">
                  <span className="tit">학력</span>
                  <span className="cont">서울 고려대 / 생명공학</span>
                </div>
                <div className="info">
                  <span className="tit">면접 유입경로</span>
                  <span className="cont">신규</span>
                </div>
                <div className="info">
                  <span className="tit">소개자</span>
                  <span className="cont">김소개103</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">면접관</span>
                  <span className="cont bold">김면접103</span>
                </div>
                <div className="info">
                  <span className="tit">면접일시</span>
                  <span className="cont">2023, 05, 12 15:30</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">면접점수</span>
                  <span className="cont com_blue_txt">태도(24) 이력(45)</span>
                </div>
                <div className="info">
                  <span className="tit">시강점수</span>
                  <span className="cont com_blue_txt">태도(24) 이력(45)</span>
                </div>
                <div className="info">
                  <span className="tit">면접관 가산점수</span>
                  <span className="cont com_blue_txt">4점</span>
                </div>
                <div className="info">
                  <span className="tit">점수/등급</span>
                  <span className="cont com_red_txt">158점 C등급</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">면접관 의견</span>
                  <span className="cont">태도나 모든 것이 좋으나 기타 다른 부분이 미흡합니다.</span>
                </div>
                <div className="info">
                  <span className="tit">파일명</span>
                  <span className="cont">
                    <div className="com_input_upload">
                      <p className="file">
                        <span className="txt">File name.pdf</span>
                        <button type="button" className="btn_del_file" onClick={() => {}}></button>
                        <button type="button" className="btn_down" onClick={() => {}}></button>
                      </p>
                    </div>
                  </span>
                </div>
              </div>

              <div className="board_item">
                <div className="info evaluation">
                  <span className="cont">
                    <span className="name">화상 평가표 </span>
                    <span className="date dot">2023, 05, 12 김면접321</span>
                  </span>
                  <div className="cont">
                    <span className="com_red_txt bold">56</span>
                    <span className="desc">(70점 미만 재시강)</span>
                  </div>
                  <button className="btn_edit"></button>
                </div>
                <hr className="com_divider" />
                <div className="com_btn_wrap  center">
                  <span className="icon_arrow_down"></span>
                </div>
              </div>
            </div>
            <div className="detail_tit_sub">
              <p className="name">화상 평가표</p>
            </div>
            <div className="com_board_list__scroll evaluation">
              <table className="com_board_list ">
                <colgroup>
                  <col width="100" />
                  <col width="auto" />
                  <col width="120" />
                </colgroup>
                <thead>
                  <tr>
                    <th>내용</th>
                    <th>문 항</th>
                    <th>답 변</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>직관</td>
                    <td>정시에 수업을 개설하고 링크를 발송했습니까?</td>
                    <td className="com_blue_txt">무단지각</td>
                  </tr>
                  <tr>
                    <td>장비체크</td>
                    <td>화면에 복장은 단정합니까?</td>
                    <td className="com_blue_txt">불량</td>
                  </tr>
                  <tr>
                    <td>ZOOM 사용</td>
                    <td>목소리(웅얼거림, 갈라짐, 너무 작음, 기타)</td>
                    <td className="com_blue_txt">웅얼거림</td>
                  </tr>
                  <tr>
                    <td>화상수업능력</td>
                    <td>강사는 카메라, 마이크, 스피커, 듀얼모니터를 사용중입니까?</td>
                    <td className="com_blue_txt">사용중</td>
                  </tr>
                  <tr>
                    <td>화상수업능력</td>
                    <td>강사는 카메라, 마이크, 스피커, 듀얼모니터를 사용중입니까?</td>
                    <td className="com_blue_txt">사용중</td>
                  </tr>
                  <tr>
                    <td>화상수업능력</td>
                    <td>강사는 카메라, 마이크, 스피커, 듀얼모니터를 사용중입니까?</td>
                    <td className="com_blue_txt">사용중</td>
                  </tr>
                  <tr>
                    <td className="bg_gray"></td>
                    <td className="bg_gray bold">총 점</td>
                    <td className="bg_gray">
                      <span className="com_red_txt">56</span> <br />
                      (70점 미만 재시강)
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <textarea name="" id="" className="textarea" placeholder="면접관 의견"></textarea>

            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
};

export default LearnerTraining;
